import { useContext } from 'react';
import { User, useFeatureFlag } from 'configcat-react';
import { default as AdminContext } from '../contexts/AdminContext';
import { useSettings } from '../routing/RoutingMediator';

export const FEATURE_FLAG = {
  MENTORSHIP: 'mentorship',
  PRIVATE_MEETINGS: 'privateMeetings',
  RECURRING_SESSIONS: 'recurringSessions',
  ACCESS_PASSES: 'accessPasses',
  EMAIL_NOTIFICATIONS: 'emailNotifications',
  DIRECTORY_TAG_FILTERS: 'directoryTagFilters',
  SESSION_TRANSCRIPTION: 'sessionTranscription',
  HIDE_NEW_CAMPAIGN_BUTTON: 'hideNewCampaignButton',
  ECOMMERCE: 'ecommerce',
  SESSION_REMINDER: 'sessionReminder',
  ENABLE_SELF_REGISTRATION: 'enableSelfRegistration',
  GIPHY: 'giphy',
} as const;

export type FeatureFlagType = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

export const useFeatureFlagWithUser = (
  key: FeatureFlagType,
  defaultValue = false,
): { value: boolean; loading: boolean } => {
  const { site, user } = useSettings();
  const { platformId } = useContext(AdminContext);
  const userObject = new User(user?.id || '', user?.email || '', '', {
    platform: site ? site.platform_id : platformId || '',
  });
  const { value, loading } = useFeatureFlag(key, defaultValue, userObject);
  return { value, loading };
};
